module.exports = __webpack_public_path__ + "static/media/thumbsUp.0040c0c3.svg";